(function() { window.GUID_4ea69189_016b_4385_9313_3fad741a7ce2 = { getGuid: function() { return "4ea69189-016b-4385-9313-3fad741a7ce2"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class PromotionPopup extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.ControlId}`);
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                this.version = params[1];
            }
            OnBindEvents() { }
            OnControlRendered() {
                if (this.version) {
                    const utcNow = new Date().toUTCString();
                    const dimensionValue = `${this.version} - ${utcNow}`;
                    console.log(`Setting dimension "playerFeaturePromoted" to "${dimensionValue}"...`);
                    CS.Analytics.Event("Promo", "playerFeaturePromoted", dimensionValue);
                }
            }
            OnDispose() { }
        }
        Controls.PromotionPopup = PromotionPopup;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=promotion-popup.js.map
